// start 1211511238800337
document.querySelectorAll('button[data-option-value]').forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
    })
});
document.querySelectorAll('.cb-thumbnail')?.forEach((el) => {
    const galleryContainer = document.querySelector('.product__media-container.above-mobile .product__media');
    el.addEventListener('click', e => {
        const mediaId = el.dataset.thumbnailMediaId;
        if (!mediaId) return;
        el.querySelector('.cb-thumbnail .product-thumbnails__item-link.active')?.classList.remove('active');
        el.querySelector('.product-thumbnails__item-link').classList.add('active');
        galleryContainer.querySelectorAll('.cb-product-media-item').forEach((mediaItem) => {
            mediaItem.classList.add('cb-hidden');
        });
        galleryContainer.querySelector(`[data-media-item-id="${mediaId}"]`).classList.remove('cb-hidden');
        galleryContainer.querySelector(`[data-media-item-id="${mediaId}"]`).classList.remove('hidden');
    });
});
document.addEventListener('product:variant-change', (e) => {
    document.querySelector('[data-current-selected-variant-id]')?.setAttribute('data-current-selected-variant-id', e.detail.variant.id);
    const thumbnailsContainer = document.querySelector('.product-thumbnails__items');
    const thumbnailsHiddenContaner = document.querySelector('.cb-variants-thumbnails-container');
    const galleryContainer = document.querySelector('.product__media-container.above-mobile .product__media');
    const galleryHiddenContainer = document.querySelector('.cb-variants-images-container');
    const swiperWrapper = document.querySelector('.product__media-container .swiper-wrapper');
    const slidesHiddenContainer = document.querySelector('.cb-variants-slides-container');
    if (!thumbnailsHiddenContaner && !galleryHiddenContainer && !slidesHiddenContainer) return;
    
    if(screen.width >= 768) {
    // update thumbnails
    
        let thumbnails = thumbnailsHiddenContaner?.querySelectorAll(`[data-thumbnail-for-variant="${e.detail.variant.id}"]`);
        if (thumbnails && thumbnails.length === 0) thumbnails = thumbnailsHiddenContaner?.querySelectorAll('.cb-product-default-thumbnail');
        if (thumbnails && thumbnails.length > 0){
            const thumbnailsHtml = Array.from(thumbnails).reduce((acc, el, index) => {
                const cloneEl = el.cloneNode(true);
                if (index === 0) cloneEl.querySelector('.product-thumbnails__item-link').classList.add('active');
                return acc+= cloneEl.outerHTML;
            }, '');
            thumbnailsContainer.innerHTML = thumbnailsHtml;
            thumbnailsContainer.querySelectorAll('.cb-thumbnail').forEach((el) => {
                el.addEventListener('click', e => {
                    const mediaId = el.dataset.thumbnailMediaId;
                    if (!mediaId) return;
                    galleryContainer.querySelectorAll('.cb-product-media-item').forEach((mediaItem) => {
                        mediaItem.classList.add('cb-hidden');
                    });
                    galleryContainer.querySelector(`[data-media-item-id="${mediaId}"]`).classList.remove('cb-hidden');
                    galleryContainer.querySelector(`[data-media-item-id="${mediaId}"]`).classList.remove('hidden');
                    thumbnailsContainer.querySelector('.product-thumbnails__item-link.active')?.classList.remove('active');
                    el.querySelector('.product-thumbnails__item-link').classList.add('active');
                });
            });
        } 

    // update gallery on desktop
        let galleryImages = galleryHiddenContainer.querySelectorAll(`[data-media-for-variant="${e.detail.variant.id}"]`);
        if (galleryImages && galleryImages.length === 0) galleryImages = galleryHiddenContainer.querySelectorAll('.cb-default-product-media-item');
        if (galleryImages && galleryImages.length > 0) {
            const galleryImagesHtml = Array.from(galleryImages).reduce((acc, el, index) => {
                const cloneEl = el.cloneNode(true);
                if (index > 0) cloneEl.classList.add('cb-hidden');
                return acc += cloneEl.outerHTML;
            }, '');
            galleryContainer.innerHTML = galleryImagesHtml;
        }
    }

    // update gallery on mobile
    if(screen.width < 767) {
        if (!swiperWrapper) return;
        swiperWrapper.querySelectorAll('.swiper-slide').forEach(el => el.remove());
        let gallerySlides = slidesHiddenContainer.querySelectorAll(`[data-media-for-variant="${e.detail.variant.id}"]`);
        if (gallerySlides.length === 0) gallerySlides = slidesHiddenContainer.querySelectorAll('.cb-default-product-swiper-slide');
        if (gallerySlides.length > 0) {
            const gallerySlidesHtml = Array.from(gallerySlides).reduce((acc, el, index) => {
                const cloneEl = el.cloneNode(true);
                cloneEl.setAttribute('data-slide-index', index);
                return acc += cloneEl.outerHTML;
            }, '');
            swiperWrapper.innerHTML = gallerySlidesHtml;
        }
        swiperWrapper.closest('.swiper').querySelector('.swiper-pagination-bullet')?.click();
    }
});
// end 1211511238800337
class Configurator extends HTMLElement {
    constructor() {
        super();
        this.swipers = this.querySelectorAll('.swiper');
        this.steps = this.querySelectorAll('.cb-configurator-step');
        this.activeStep = this.steps[0];
        this.activeTab = this.querySelectorAll('.cb-configurator-tab')[0];
        this.activeSummaryBlock = this.querySelectorAll('.cb-configurator-summary-block')[0];
        this.fenceDependencies = JSON.parse(this.querySelector('#fence-dependencies').textContent);
        
        this.activeFenceDependencies = null;
        this.setupListeners();
        this.setupObservers();
        this.initSelections();
        this.steps.forEach(step => {
            const firstOptionBlock = step.querySelector('.cb-option-block');
            if (step.classList.contains('cb-step-fence')) {
                this.updateFenceSummary(firstOptionBlock);
            } else if (step.classList.contains('cb-step-post')) {
                const summaryBlock = this.querySelector('[data-summary-block="post"]');
                this.updatePostSummary(firstOptionBlock, summaryBlock);
            } else if (step.classList.contains('cb-step-gate')) {
                const summaryBlock = this.querySelector('[data-summary-block="gate"]');
                this.updateGateSummary(firstOptionBlock, summaryBlock);
            }
        });
    }

    initSelections() {
        this.steps.forEach((step) => {
            if (step.classList.contains('cb-step-fence')) {
                const type = step.querySelector('.cb-type-option').dataset.type;
                const productOption = step.querySelector(`[data-product-option-for="${type}"] .cb-product-option`);
                this.activeFenceDependencies = this.fenceDependencies.find(el => el.fenceProductId === +productOption.dataset.productId);
                if(productOption) productOption.classList.add('active');
            } else if (step.classList.contains('cb-step-post')) {
                
                const type = step.querySelector('.cb-type-option').dataset.typeTranslation.toLowerCase();
                let activePost = this.activeFenceDependencies.posts.find(post => post.available && post.default && post.type === type);
                if (!activePost){
                    activePost = this.activeFenceDependencies.posts.find(post => post.available && post.type === type);
                }
                if (activePost) {
                    step.querySelector(`.cb-product-option[data-product-id="${activePost.productId}"]`)?.classList.add('active');
                }

                let activeCornerPost = this.activeFenceDependencies.cornerPosts.find(post => post.available && post.default && post.type === type);
                if (!activeCornerPost){
                    activeCornerPost = this.activeFenceDependencies.cornerPosts.find(post => post.available && post.type === type);
                }
                if (activeCornerPost) {
                    step.querySelector(`.cb-product-option-2[data-product-id="${activeCornerPost.productId}"]`)?.classList.add('active');
                }

                this.querySelectorAll('.cb-step-gate .cb-gate-post-option.active').forEach(option => option.classList.remove('active'));
                const defaulGatePost = this.activeFenceDependencies.gatePosts.find(el => el.default);
                if (defaulGatePost) {
                    this.querySelectorAll(`.cb-step-gate [data-gate-post-product-id="${defaulGatePost.productId}"]`).forEach(option => {
                        option.classList.add('active');
                    });
                }
            } else if (step.classList.contains('cb-step-gate')) {
                const type = step.querySelector('.cb-type-option').dataset.type;
                const postType = this.querySelector('.cb-step-post .cb-type-option').dataset.type.toLowerCase();
                const gateProductId = this.querySelector('.cb-step-fence .cb-product-option.active').dataset.relatedGateProductId;
                const variantOption = step.querySelector(`.cb-variant-option[data-variant-for-type="${type}"][data-variant-for-product="${gateProductId}"][data-option-available="true"]`);
                if (variantOption) variantOption.classList.add('active');
            }
        });
    }

    setupListeners(container){
        this.querySelectorAll('.cb-option').forEach((el) => {
            el.addEventListener('click', e => {
                this.onOptionChange(e);
            });
        });
        this.querySelectorAll('.cb-dimension-input').forEach(el => {
            el.addEventListener('input', e => {
                this.onInputValueChange(e);
            });
        });
        this.querySelectorAll('[data-configurator-step-next]').forEach(el => {
            el.addEventListener('click', e => {
                this.onNextStep();
            });
        })
        this.querySelectorAll('[data-configurator-step-prev]').forEach(el => {
            el.addEventListener('click', e => {
                this.onPrevStep();
            });
        });
        this.querySelectorAll('.cb-configurator-tab').forEach(el => {
            el.addEventListener('click', e => {
                this.onTabClick(e);
            });
        });
        this.querySelectorAll('.cb-configurator-quantity-input input').forEach(el => {
            el.addEventListener('input', e => {
                this.onInputValueChange(e);
            });
            el.addEventListener('cb:quantity:change', e => {
                this.onInputValueChange(e);
            });
        });
        this.querySelectorAll('.cb-configurator-step-skip-toggler input').forEach((el) => {
            el.addEventListener('change', e => {
                this.onSkipStep(e);
            });
        });
        this.querySelectorAll('[data-minus]').forEach(el => {
            el.addEventListener('click', e => {
                this.onMinusClick(e);
            });
        });
        this.querySelectorAll('[data-plus]').forEach(el => {
            el.addEventListener('click', e => {
                this.onPlusClick(e);
            });
        });
        
        if(!window.matchMedia('(hover: hover)').matches){
            this.querySelectorAll('.cb-tooltip').forEach((el) => {
                el.addEventListener('touchend', e => {
                    e.stopPropagation();
                    e.preventDefault();
                    e.target.closest('.cb-tooltip').classList.toggle('active');
                });
            });
        }
        this.querySelectorAll('[data-add-options]').forEach((el) => {
            el.addEventListener('click', (e) => {
                this.onAddOptionBlock(e);
            });
        });
        this.querySelectorAll('.cb-step-extras .cb-configurator-quantity-input [data-quantity-input]').forEach((el) => {
            el.addEventListener('input', (e) => {
                this.onUpdateExtrasSummaryRow(e);
            });
        });
        this.querySelectorAll('.cb-step-extras .cb-configurator-quantity-input [data-quantity-input]').forEach((el) => {
            el.addEventListener('cb:quantity:change', (e) => {
                this.onUpdateExtrasSummaryRow(e);
            });
        });
        this.querySelectorAll('.cb-configurator-product-card').forEach((el) => {
            el.addEventListener('change', (e) => {
                if(el.querySelector('input[type="checkbox"]:checked')) {
                    this.onAddExtraProduct(e);
                } else {
                    this.onRemoveExtraProduct(e);
                }
            });
        });
        this.querySelectorAll('.cb-step-extras .cb-select-input').forEach((el) => {
            el.addEventListener('change', (e) => {
                this.onExtraProductVariantChange(e);
            });
        });
        this.querySelectorAll('[data-configurator-atc]').forEach((el) => {
            el.addEventListener('click', e => {
                this.onFormSubmit(e);
            });
        });
    }

    setupObservers() {
        this.querySelectorAll('.cb-configurator-summary-block [data-step-price]').forEach((el) => {
            const observer = new MutationObserver(() => {
                this.onTotalPriceChange();
            });

            observer.observe(el, {
                characterData: true,
                childList: true,
                subtree: true
            });
        });
    }

    onOptionChange(e) {
        if (e.target.classList.contains('active')) return;
        const block = e.target.closest('.cb-option-block');
        if (this.activeStep.classList.contains('cb-step-fence')) {
            this.activeStep.classList.remove('complete');
            this.onFenceOptionChange(e.target);
            this.updateFenceSummary(block);
            const postOptionBlock = this.querySelector('.cb-step-post .cb-option-block');
            const postSummaryBlock = this.querySelector('[data-summary-block="post"]');
            this.updatePostSummary(postOptionBlock, postSummaryBlock);
            
            const gateProductId = this.activeFenceDependencies.gateProductId;
            this.querySelectorAll('.cb-step-gate .cb-option-block').forEach(gateBlock => {
                gateBlock.querySelector('.cb-variant-option.active').classList.remove('active');
                const gateType = gateBlock.querySelector('.cb-type-option.active')?.dataset.typeTranslation;
                gateBlock.querySelector(`.cb-variant-option[data-variant-for-product="${gateProductId}"][data-variant-for-type="${gateType}"][data-option-available="true"]`).classList.add('active');
            });

            const gateSummaryBlock = this.querySelector('[data-summary-block="gate"]');
            this.querySelectorAll('.cb-step-gate .cb-option-block').forEach(el => {
                this.updateGateSummary(el, gateSummaryBlock);
            });
            this.updatePostAvailability();
        } else if (this.activeStep.classList.contains('cb-step-post')) {
            this.onPostOptionChange(e.target);
            this.updatePostSummary(block);
            const gateSummaryBlock = this.querySelector('[data-summary-block="gate"]');
            const gateProductId = this.activeFenceDependencies.gateProductId;
            this.querySelectorAll('.cb-step-gate .cb-option-block').forEach(gateBlock => {
                gateBlock.querySelectorAll('.cb-variant-option.active').forEach(optionEl => optionEl.classList.remove('active'));
                const gateType = gateBlock.querySelector('.cb-type-option.active')?.dataset.typeTranslation;
                gateBlock.querySelector(`.cb-variant-option[data-variant-for-product="${gateProductId}"][data-variant-for-type="${gateType}"][data-option-available="true"]`).classList.add('active');
                this.updateGateSummary(gateBlock, gateSummaryBlock);
            });
        } else if (this.activeStep.classList.contains('cb-step-gate')) {
            this.onGateOptionChange(e.target);
            this.updateGateSummary(block);
        }
        this.updateStepCompleteness();
    }

    updatePostAvailability(){
        this.querySelectorAll('.cb-step-post .cb-product-option').forEach(el => {
            el.classList.remove('active');
            if (this.activeFenceDependencies.posts.length < 1) {
                el.setAttribute('data-option-available', 'false'); 
            } else {
                const relativePost = this.activeFenceDependencies.posts.find(post => post.productId === +el.dataset.productId);
                if (relativePost) { 
                    el.setAttribute('data-option-available', relativePost.available);
                } else {
                    el.setAttribute('data-option-available', 'false'); 
                }
            }
        });
        this.querySelectorAll('.cb-step-gate .cb-gate-post-option').forEach(el => {
            el.classList.remove('active');
            if (this.activeFenceDependencies.gatePosts.length < 1) {
                el.setAttribute('data-option-available', 'false'); 
            } else {
                const relativePost = this.activeFenceDependencies.gatePosts.find(post => post.productId === +el.dataset.gatePostProductId);
                if (relativePost) { 
                    el.setAttribute('data-option-available', relativePost.available);
                } else {
                    el.setAttribute('data-option-available', 'false'); 
                }
            }
        });
        const postType = this.querySelector('.cb-step-post .cb-type-option.active').dataset.typeTranslation;
        const relativeCornerPosts = this.activeFenceDependencies.cornerPosts;
        const cornerPostInput = this.querySelector('.cb-step-post .cb-configurator-quantity-input');
        const min = +cornerPostInput.querySelector('input').min;
        if (relativeCornerPosts.length > 0) {
            let hasAvailableCornerPost = false;
            this.querySelectorAll('.cb-step-post .cb-product-option-2').forEach(cornerPost => {
                cornerPost.classList.remove('active');
                const relatedCornerPost = relativeCornerPosts.find(el => el.productId === +cornerPost.dataset.productId);
                if (relatedCornerPost && relatedCornerPost.available){
                    cornerPost.setAttribute('data-option-available', relatedCornerPost.available);
                    hasAvailableCornerPost = true;
                } else {
                    cornerPost.setAttribute('data-option-available', false);
                }
            });
            
            if (hasAvailableCornerPost) {
                cornerPostInput.classList.remove('cb-disabled');
            } else {
                cornerPostInput.classList.add('cb-disabled');
                cornerPostInput.querySelector('input').value = min;
            }
        } else {
            cornerPostInput.classList.add('cb-disabled');
            cornerPostInput.querySelector('input').value = min;
        }
        this.updatePostSelection(postType);
    }

    updatePostSelection(postType) {
        let postToSelect = this.querySelector(`.cb-step-post .cb-product-option[data-product-option-for="${postType}"][data-default-option="true"][data-option-available="true"]`);
        if (postToSelect) {
            postToSelect.classList.add('active');
        } else {
            postToSelect = this.querySelector(`.cb-step-post .cb-product-option[data-product-option-for="${postType}"][data-option-available="true"]`);
            if (postToSelect) postToSelect.classList.add('active');
        }

        let cornerPostToSelect = this.querySelector(`.cb-step-post .cb-product-option-2[data-product-option-for="${postType}"][data-default-option="true"][data-option-available="true"]`);
        if (cornerPostToSelect) {
            cornerPostToSelect.classList.add('active');
        } else {
            cornerPostToSelect = this.querySelector(`.cb-step-post .cb-product-option-2[data-product-option-for="${postType}"][data-option-available="true"]`);
            if (cornerPostToSelect) cornerPostToSelect.classList.add('active');
        }

        const relatedGatePosts = this.activeFenceDependencies.gatePosts.filter(el => el.type === postType);
        const derfaultGatePost = relatedGatePosts.find(el => el.default);
        this.querySelectorAll('.cb-step-gate .cb-option-block').forEach(block => {
            block.querySelector('.cb-gate-post-option.active')?.classList.remove('active');
            if (derfaultGatePost && derfaultGatePost.available) { 
                block.querySelector(`.cb-gate-post-option[data-gate-post-product-id="${derfaultGatePost.productId}"]`)?.classList.add('active');
            } else {
                const availableGatePost = relatedGatePosts.find(el => el.available);
                if (availableGatePost) {
                    block.querySelector(`.cb-gate-post-option[data-gate-post-product-id="${availableGatePost.productId}"]`)?.classList.add('active');
                }
            }
        });
    }

    onFenceOptionChange(target) {
        const block = target.closest('.cb-option-block');
        target.closest('.cb-options').querySelector('.cb-option.active')?.classList.remove('active');
        if (target.classList.contains('cb-type-option')) {
            block.querySelector('.cb-product-option.active')?.classList.remove('active');
            const type = target.dataset.type;
            const firstProduct = block.querySelector(`[data-product-option-for="${type}"] .cb-product-option`);
            firstProduct.classList.add('active');
            this.activeFenceDependencies = this.fenceDependencies.find(el => el.fenceProductId === +firstProduct.dataset.productId);
            block.querySelector('.cb-variant-option.active')?.classList.remove('active');
        } else if (target.classList.contains('cb-product-option')) {
            block.querySelector('.cb-variant-option.active')?.classList.remove('active');
            this.activeFenceDependencies = this.fenceDependencies.find(el => el.fenceProductId === +target.dataset.productId);
        } 
        if (target.classList.contains('cb-type-option') || target.classList.contains('cb-product-option')) {
            this.querySelectorAll('.cb-step-gate .cb-option-block').forEach((el) => {
                const gateProductId = this.activeFenceDependencies.gateProductId;
                const gateType = el.querySelector('.cb-type-option').dataset.typeTranslation;
                const activeVariant = el.querySelector('.cb-variant-option.avtive');
                activeVariant?.classList.remove('active');
                const variantToActive = el.querySelector(`.cb-variant-option[data-variant-for-type="${gateType}"][data-variant-for-product="${gateProductId}"][data-option-available="true"]`);
                variantToActive?.classList.add('active');
            });
        }
        target.classList.add('active');
    }

    onPostOptionChange(target) {
        const block = target.closest('.cb-option-block');
        target.closest('.cb-options').querySelector('.cb-option.active')?.classList.remove('active');
        if (target.classList.contains('cb-type-option')) {
            block.querySelector('.cb-product-option.active')?.classList.remove('active');
            block.querySelector('.cb-product-option-2.active')?.classList.remove('active');
            const type = target.dataset.typeTranslation.toLowerCase();
            this.updatePostSelection(type);
            this.querySelectorAll('.cb-step-gate .cb-option-block').forEach((gateBlock) => {
                const gateProductId = this.activeFenceDependencies.gateProductId;
                const gateType = gateBlock.querySelector('.cb-type-option').dataset.typeTranslation;
                const activeVariant = gateBlock.querySelector('.cb-variant-option.avtive');
                activeVariant?.classList.remove('active');
                const variantToActive = gateBlock.querySelector(`.cb-variant-option[data-variant-for-type="${gateType}"][data-variant-for-product="${gateProductId}"][data-option-available="true"]`);
                variantToActive?.classList.add('active');
            });
        }
        target.classList.add('active');
    }

    onGateOptionChange(target) {
        const block = target.closest('.cb-option-block');
        target.closest('.cb-options').querySelector('.cb-option.active')?.classList.remove('active');
        if (target.classList.contains('cb-type-option')) {
            block.querySelector('.cb-variant-option.active')?.classList.remove('active');
            const type = target.dataset.type;
            const gateProductId = this.activeFenceDependencies.gateProductId;
            block.querySelector(`[data-variant-for-type="${type}"][data-variant-for-product="${gateProductId}"][data-option-available="true"]`)?.classList.add('active');
        }
        target.classList.add('active');
    }

    updateFenceSummary(block) {
        const {type} = block.querySelector('.cb-type-option.active')?.dataset;
        const fenceCount = Math.ceil(+block.querySelector('.cb-dimension-input').value / 5);
        const height = block.querySelector('.cb-product-option.active')?.dataset.productHeight;
        const slatSpacing = block.querySelector('.cb-variant-option.active')?.dataset.slatSpacing;
        const variantPrice = block.querySelector('.cb-variant-option.active')?.dataset.variantPrice;

        const typeSummaryEl = this.activeSummaryBlock.querySelector('[data-fence-type-summary]');
        const lengthSummaryEl = this.activeSummaryBlock.querySelector('[data-length-summary]');
        const heightSummaryEl = this.activeSummaryBlock.querySelector('[data-height-summary]');
        const slatSpacingSummaryEl = this.activeSummaryBlock.querySelector('[data-slat-spacing-summary]');

        const tabPriceEl = this.activeTab.querySelector('[data-step-price]');
        const summaryPriceEl = this.activeSummaryBlock.querySelector('[data-step-price]');

        if (type) typeSummaryEl.textContent = type;
        fenceCount > 0 ? lengthSummaryEl.textContent = `${fenceCount * 5}m` : lengthSummaryEl.textContent = '';
        if (height) heightSummaryEl.textContent = height;
        slatSpacing ? slatSpacingSummaryEl.textContent = slatSpacing : slatSpacingSummaryEl.textContent = slatSpacing;

        if (variantPrice && fenceCount > 0) {
            const total = variantPrice * fenceCount;
            const formatTotal = `€${(total / 100).toFixed(2).replace('.', ',')}`;
            tabPriceEl.textContent = formatTotal;
            tabPriceEl.setAttribute('data-step-price', total);
            summaryPriceEl.textContent = formatTotal;
            summaryPriceEl.setAttribute('data-step-price', total);
        } else {
            tabPriceEl.textContent = '';
            tabPriceEl.setAttribute('data-step-price', '');
            summaryPriceEl.textContent = '';
            summaryPriceEl.setAttribute('data-step-price', '');
        }
    }

    onInputValueChange(e) {
        this.updateStepCompleteness();
        const stepType = this.activeStep.dataset.step.split('-')[0].split('configurator_')[1];
        const block = e.target.closest('.cb-option-block');
        if (stepType === 'fence') {
            this.updateFenceSummary(block);
            const postOptionBlock = this.querySelector('.cb-step-post .cb-option-block');
            const postSummaryBlock = this.querySelector('[data-summary-block="post"]');
            this.updatePostSummary(postOptionBlock, postSummaryBlock);
        } else if (stepType === 'post'){
            this.updatePostSummary(block);
            if (e.target.closest('.cb-corner-post-quantity-input')){
                const value = e.target.value;
                value > 0 ? this.activeStep.classList.add('cb-with-corner-post') : this.activeStep.classList.remove('cb-with-corner-post');
            }
        } else if (stepType === 'gate'){
            this.updateGateSummary(block);
        } else if (stepType === 'extras') {
            this.onUpdateExtrasSummaryRow(e);
        }
    }

    onTotalPriceChange() {
        const stepPriceEls = [...this.querySelectorAll('.cb-configurator-summary-block:not(.skip)')].filter(el => {
            return el.classList.contains('active') || el.classList.contains('complete');
        }).map(el => el.querySelector('[data-step-price]'));
        if (stepPriceEls.length > 0) {
            let total = [...stepPriceEls].reduce((acc, el) => acc + (+el.dataset.stepPrice) , 0);
            total = total / 100;
            total = total.toFixed(2);
            this.querySelectorAll('[data-configurator-total]').forEach(el => {
                el.textContent = `€ ${total}`;
            });
        }
    }

    onAddOptionBlock(e) {
        const step = e.target.closest('.cb-configurator-step');
        const optionBlocks = step.querySelectorAll('[data-options-block]');
        const copy = optionBlocks[optionBlocks.length - 1].cloneNode(true);
        const nextIndex = optionBlocks.length + 1;

        const summaryStepBlocks = this.activeSummaryBlock.querySelectorAll('.cb-summary-block-content');
        const summaryStepBlockCopy = summaryStepBlocks[summaryStepBlocks.length - 1].cloneNode(true);
        summaryStepBlockCopy.querySelector('[data-remove-after-copy]')?.remove();

        copy.setAttribute('data-options-block', nextIndex);
        copy.querySelector('.cb-divider-header').style.setProperty('--i', `"${nextIndex}"`);

        summaryStepBlockCopy.setAttribute('data-summary-sub-block', nextIndex);
        summaryStepBlockCopy.querySelector('[data-summary-sub-block-number]').textContent = nextIndex;

        copy.querySelector('[data-remove-option-block]').addEventListener('click', (e) => {
            this.onRemoveOptionBlock(e);
        });
        copy.querySelectorAll('.cb-option')?.forEach((el) => {
            el.addEventListener('click', e => {
                this.onOptionChange(e);
            });
        });
        copy.querySelector('[data-minus]').addEventListener('click', e => {
            this.onMinusClick(e);
        });
        copy.querySelector('[data-plus]').addEventListener('click', e => {
            this.onPlusClick(e);
        });
        copy.querySelector('.cb-configurator-quantity-input input').addEventListener('input', e => {
            this.onInputValueChange(e);
        });
        copy.querySelector('.cb-configurator-quantity-input input').addEventListener('cb:quantity:change', e => {
            this.onInputValueChange(e);
        });
        copy.classList.add('copy');
        summaryStepBlockCopy.classList.add('copy');
        optionBlocks[optionBlocks.length - 1].insertAdjacentElement('afterend', copy);
        summaryStepBlocks[summaryStepBlocks.length - 1].insertAdjacentElement('afterend', summaryStepBlockCopy);
        const quantityInputId = copy.querySelector('.cb-configurator-quantity-input input').id;
        const newQuantityInputId = quantityInputId + '-copy-' + nextIndex;
        copy.querySelector('.cb-configurator-quantity-input input').id = newQuantityInputId;
        copy.querySelector('.cb-configurator-quantity-input').id = newQuantityInputId;
        this.updateGateSummary(copy);
    }

    onRemoveOptionBlock(e) {
        const block = e.target.closest('[data-options-block]');
        const step = e.target.closest('.cb-configurator-step');
        const stepType = step.dataset.step.split('-')[0].split('_')[1];
        const blockNumber = block.dataset.optionsBlock;
        this.querySelector(`[data-summary-block="${stepType}"] [data-summary-sub-block="${blockNumber}"]`).remove();
        block.remove();
        step.querySelectorAll('.cb-option-block').forEach((el, i) => {
            el.setAttribute('data-options-block', (i+1));
            el.querySelector('.cb-divider-header').style = `--i:"${i+1}"`;
        });
        this.querySelectorAll(`[data-summary-sub-block="${stepType}"] .cb-summary-block-content`).forEach((el, i) => {
            el.setAttribute('data-summary-sub-block', (i+1));
            el.querySelector('[data-summary-sub-block-number]').textContent = `${i+1}`;
        });
        this.updateGateTotalPrice();
    }

    onSkipStep(e){
        const step = e.target.closest('.cb-configurator-step');
        if (e.target.checked) {
            step.classList.add('skip');
            this.activeSummaryBlock.classList.add('skip');
            this.activeTab.classList.add('skip');
        } else {
            step.classList.remove('skip');
            this.activeSummaryBlock.classList.remove('skip');
            this.activeTab.classList.remove('skip');
        }
        this.onTotalPriceChange();
    }

    onMinusClick(e) {
        const input = e.target.closest('.cb-configurator-quantity-input').querySelector('input');
        const min = input.getAttribute('min');
        if (+min > +input.value) e.target.classList.add('cb-quantity-btn-disabled');
        const event = new Event('cb:quantity:change', { bubbles: true });
        input.value = +input.value - 1;
        if (+min >= +input.value) e.target.classList.add('cb-quantity-btn-disabled');
        input.dispatchEvent(event);
    }

    onPlusClick(e) {
        const input = e.target.closest('.cb-configurator-quantity-input').querySelector('input');
        const minusEl = e.target.closest('.cb-configurator-quantity-input').querySelector('[data-minus]');
        const event = new Event('cb:quantity:change', { bubbles: true });
        input.value = +input.value + 1;
        minusEl.classList.remove('cb-quantity-btn-disabled');
        input.dispatchEvent(event);
    }

    onNextStep(){
        const nextStepIndex = Array.from(this.steps).findIndex(step => step === this.activeStep) + 1;
        if (nextStepIndex < this.steps.length) {
            this.goToStep(nextStepIndex);
        }

    }
    onPrevStep() {
        const prevStepIndex = Array.from(this.steps).findIndex(step => step === this.activeStep) - 1;
        if (prevStepIndex >= 0) {
            this.goToStep(prevStepIndex);
        }
    }

    onTabClick(e) {
        const index = e.currentTarget.dataset.tabIndex;
        if (index) {
            this.goToStep(index);
        }
    }

    goToStep(index) {
        this.activeStep.classList.remove('active');
        this.activeStep = this.steps[index];
        this.activeStep.classList.add('active');
        this.activeTab.classList.remove('active');
        this.activeTab = this.querySelectorAll('.cb-configurator-tab')[index];
        this.activeTab.classList.add('active');
        this.activeSummaryBlock.classList.remove('active');
        this.activeSummaryBlock = this.querySelectorAll('.cb-configurator-summary-block')[index];
        this.activeSummaryBlock.classList.add('active');
        this.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
        this.updateStepCompleteness();
        this.onTotalPriceChange();
    }

    updateStepCompleteness() {
        const stepType = this.activeStep.dataset.step.split('-')[0].split('_')[1];
        if (stepType === 'fence') {
            const rqueiredOptionsSelect = 3;
            const inputComplete = this.activeStep.querySelector('.cb-required-input').value !== '';
            const optionsComplete = this.activeStep.querySelectorAll('.cb-required-select .cb-option.active').length === rqueiredOptionsSelect;
            if (inputComplete && optionsComplete) {
                this.activeStep.classList.add('complete');
                this.activeSummaryBlock.classList.add('complete');
                this.activeTab.classList.add('complete');
            } else {
                this.activeStep.classList.remove('complete');
                this.activeSummaryBlock.classList.remove('complete');
                this.activeTab.classList.remove('complete');
            }
        } else if (stepType === 'post') {
            const selectedProduct = this.activeStep.querySelector('.cb-product-options .cb-product-option.active:not(.cb-unavailable):not(.cb-disabled)');
            if (selectedProduct) {
                this.activeStep.classList.add('complete');
                this.activeSummaryBlock.classList.add('complete');
                this.activeTab.classList.add('complete');
            } else {
                this.activeStep.classList.remove('complete');
                this.activeSummaryBlock.classList.remove('complete');
                this.activeTab.classList.remove('complete');
            }
        } else if (stepType === 'gate') {
            let gateStepComplete = true;
            this.activeStep.querySelectorAll('.cb-required-select').forEach((el) => {
                if (!el.querySelector('.cb-option.active')) {
                    gateStepComplete = false;
                }
            });
            this.activeStep.querySelectorAll('.cb-required-input').forEach((el) => {
                if (+el.value < 0){
                    gateStepComplete = false;
                }
            });
            if (gateStepComplete) {
                this.activeStep.classList.add('complete');
                this.activeSummaryBlock.classList.add('complete');
                this.activeTab.classList.add('complete');
            } else {
                this.activeStep.classList.remove('complete');
                this.activeSummaryBlock.classList.remove('complete');
                this.activeTab.classList.remove('complete');
            }
        }
    }

    updatePostSummary(block, summaryBlock = this.activeSummaryBlock) {
        const activeProductEl = block.querySelector('.cb-product-option.active'); 
        const activeOptionEl = block.querySelector('.cb-type-option.active');
        const activeCornerPostEl = block.querySelector('.cb-product-option-2.active');
        const type = activeOptionEl.dataset.typeTranslation;
        const summaryPriceTotal = summaryBlock.querySelector('[data-step-price]');
        const tabPriceTotal = this.querySelector('[data-tab="post"] [data-step-price]');
        const cornerPostObj = this.activeFenceDependencies.cornerPosts.find(el => el.productId === +activeCornerPostEl.dataset.productId);
        const summaryWoodTypeEls = this.querySelector('[data-post-wood-type-summary]');
        summaryWoodTypeEls.textContent = activeOptionEl.dataset.type;

        let finalPrice = 0;
        if (activeProductEl) {
            const postTitleEl = summaryBlock.querySelector('[data-post-product-title-summary]');
            const postLengthEl = summaryBlock.querySelector('[data-post-length-summary]');
            const postQuantityEl = summaryBlock.querySelector('[data-post-quantity-summary]');
            const activePostProductId = +activeProductEl.dataset.productId;
            const fenceLength = Math.ceil(+this.querySelector('.cb-step-fence .cb-dimension-input').value / 5) * 5;
            const postGap = this.activeFenceDependencies.postGap;
            const postQuantity = Math.ceil(fenceLength / postGap);
            const postObj = this.activeFenceDependencies.posts.find(el => el.productId === activePostProductId);
            postQuantityEl.textContent = postQuantity;
            postLengthEl.textContent = cornerPostObj.length;
            postTitleEl.textContent = activeProductEl.dataset.productTitle;
            if (postObj) {
                finalPrice += postQuantity * postObj.price;
            } 
        }
        const corenrPostTitleEl = summaryBlock.querySelector('[data-corner-post-product-title-summary]');
        const corenrPostLengthEl = summaryBlock.querySelector('[data-corner-post-length-summary]');
        const cornerPostQuantity = +block.querySelector('.cb-configurator-quantity-input input').value;
        const summaryCornerPostQuantityEl = summaryBlock.querySelector('[data-corner-post-quantity-summary]');
        if (cornerPostObj && cornerPostObj.available) {
            summaryCornerPostQuantityEl.textContent = cornerPostQuantity;
            corenrPostTitleEl.textContent = cornerPostObj?.productTitle;
            corenrPostLengthEl.textContent = cornerPostObj?.length;
            finalPrice += cornerPostQuantity * cornerPostObj.price;
        } else {
            corenrPostTitleEl.textContent = '';
            corenrPostLengthEl.textContent = '';
        }
        if (finalPrice > 0) {
            const formatPrice = `€${(finalPrice / 100).toFixed(2)}`;
            tabPriceTotal.textContent = formatPrice;
            tabPriceTotal.setAttribute('data-step-price', finalPrice);
            summaryPriceTotal.textContent = formatPrice;
            summaryPriceTotal.setAttribute('data-step-price', finalPrice);
        } else {
            tabPriceTotal.textContent = '';
            tabPriceTotal.setAttribute('data-step-price', '');
            summaryPriceTotal.textContent = '';
            summaryPriceTotal.setAttribute('data-step-price', '');
        }
    }

    updateGateSummary(block, summaryBlock = this.activeSummaryBlock) {
        const blockCount = block.dataset.optionsBlock;
        const summaryStepBlock = summaryBlock.querySelector(`[data-summary-sub-block="${blockCount}"]`);
        const summaryTypeEl = summaryStepBlock.querySelector('[data-gate-type-summary]');
        const summarySizeEl = summaryStepBlock.querySelector('[data-gate-size-summary]');
        const summaryQuantityEl = summaryStepBlock.querySelector('[data-gate-quantity-summary]');
        const summaryPriceEl = summaryBlock.querySelector('[data-step-price]');
        const tabPriceEl = this.querySelector('[data-tab="gate"] [data-step-price]');

        const typeEl = block.querySelector('.cb-type-option.active');
        const sizeEl = block.querySelector('.cb-variant-option.active');
        const quantity = +block.querySelector('.cb-configurator-quantity-input input').value;
        const gatePostEl = block.querySelector('.cb-gate-post-option.active');
        const gateVariantEl = block.querySelector('.cb-variant-option.active');
        let gatePrice = 0;
        let gateFinalPrice = 0;
        let postFinalPrice = 0;
        
        if (typeEl){
            summaryTypeEl.textContent = typeEl.dataset.typeTranslation;
        } else {
            summaryTypeEl.textContent = '';
        }

        if (sizeEl){
            summarySizeEl.textContent = sizeEl.dataset.variantSize;
        } else {
            summarySizeEl.textContent = '';
        }

        if (gateVariantEl) {
            gatePrice = +gateVariantEl.dataset.variantPrice;
            gateFinalPrice = quantity * gatePrice;
        }
        if (gatePostEl) {
            const gatePostId = +gatePostEl.dataset.gatePostProductId;
            const postPrice = this.activeFenceDependencies.gatePosts.find(el => el.productId === gatePostId)?.price;
            postFinalPrice = quantity * 2 * postPrice;
        }
        const stepBlockFinalPrice = gateFinalPrice + postFinalPrice;
        summaryStepBlock.setAttribute('data-summary-step-block-price', stepBlockFinalPrice);
        summaryQuantityEl.textContent = quantity;
        this.updateGateTotalPrice();
    }

    onAddExtraProduct(e){
        if (e.target.classList.contains('cb-select-input') || e.target.classList.contains('quantity-input__input')) return;
        const productCard = e.target.closest('.cb-configurator-product-card');
        let title = productCard.dataset.productTitle;
        let price = +productCard.dataset.productPrice;
        if (productCard.dataset.hasVariants === "true"){
            const variantDropdown = productCard.querySelector('select');
            const selectVariant = variantDropdown.options[variantDropdown.selectedIndex];
            price = +selectVariant.dataset.variantPrice;
            title = title + ' ' + selectVariant.dataset.variantTitle;
        }
        const quantity = +productCard.querySelector('[data-quantity-input]').value;
        const productFinalPrice = price * quantity;
        const row = document.createElement('p');
        row.className = 'cb-summary-row';
        row.setAttribute('data-row-id', productCard.dataset.configuratorExtraProduct);
        row.setAttribute('data-related-product-price', productFinalPrice);
        const rowTitle = document.createElement('span');
        rowTitle.className = 'cb-summary-row-title';
        rowTitle.textContent = title + ': ';
        const rowValue = document.createElement('span');
        rowValue.className = 'cb-summary-row-val';
        rowValue.textContent = quantity;
        row.append(rowTitle, ' ', rowValue);
        this.activeSummaryBlock.querySelector('.cb-summary-block-content').appendChild(row);
        this.updateExtrasTotalPrice();
    }

    onRemoveExtraProduct(e) {
        const productId = e.target.closest('.cb-configurator-product-card').dataset.configuratorExtraProduct;
        const row = this.activeSummaryBlock.querySelector(`[data-row-id="${productId}"]`);
        if (row) {
            row.remove();
            this.updateExtrasTotalPrice();
        }
    }


    onUpdateExtrasSummaryRow(e){
        const productCard = e.target.closest('.cb-configurator-product-card');
        const productId = productCard.dataset.configuratorExtraProduct;
        const summaryRow = this.activeSummaryBlock.querySelector(`[data-row-id="${productId}"]`);
        if (!summaryRow) return;
        let price = +productCard.dataset.productPrice;
        if (productCard.hasAttribute('data-has-variants="true"')) {
            const variantDropdown = productCard.querySelector('select');
            const selectVariant = variantDropdown.options[variantDropdown.selectedIndex];
            price = selectVariant.dataset.variantPrice;
        }
        const quantity = +productCard.querySelector('[data-quantity-input]').value;
        const productFinalPrice = price * quantity;
        summaryRow.setAttribute('data-related-product-price', productFinalPrice);
        summaryRow.querySelector('.cb-summary-row-val').textContent = quantity;
        this.updateExtrasTotalPrice();
    }

    updateExtrasTotalPrice() {
        const total = [...this.activeSummaryBlock.querySelectorAll('[data-related-product-price]')].reduce((acc, el) => {return acc+= +el.dataset.relatedProductPrice}, 0);
        const formatedTotal = `€${(total / 100).toFixed(2)}`;
        this.activeSummaryBlock.querySelector('[data-step-price]').setAttribute('data-step-price', total);
        this.activeSummaryBlock.querySelector('[data-step-price]').textContent = formatedTotal;
        this.activeTab.querySelector('[data-step-price]').setAttribute('data-step-price', total);
        this.activeTab.querySelector('[data-step-price]').textContent = formatedTotal;
    }

    onExtraProductVariantChange(e) {
        const productCard = e.target.closest('.cb-configurator-product-card');
        const productId = productCard.dataset.configuratorExtraProduct;
        const summaryRow = this.activeSummaryBlock.querySelector(`[data-row-id="${productId}"]`);
        if (!summaryRow) return;
        const variantDropdown = productCard.querySelector('select');
        const selectVariant = variantDropdown.options[variantDropdown.selectedIndex];
        const title = productCard.dataset.productTitle + ': ' + selectVariant.dataset.variantTitle;
        const quantity = +productCard.querySelector('.cb-configurator-quantity-input input').value;
        const price = +selectVariant.dataset.variantPrice;
        const finalPrice = quantity * price;
        summaryRow.setAttribute('data-related-product-price', finalPrice);
        summaryRow.querySelector('.cb-summary-row-title').textContent = title;
        this.updateExtrasTotalPrice();
    }

    updateGateTotalPrice() {
        const total = [...this.querySelectorAll('[data-summary-block="gate"] [data-summary-step-block-price]')].reduce((acc, el) => {
            const price = +el.dataset.summaryStepBlockPrice;
            return price ? acc += price : acc;
        }, 0);
        const formatTotal = `€${(total / 100).toFixed(2)}`;
        const summaryPriceEl = this.querySelector('[data-summary-block="gate"] [data-step-price]');
        const tabPriceEl = this.querySelector('[data-tab="gate"] [data-step-price]');
        summaryPriceEl.textContent = formatTotal;
        summaryPriceEl.setAttribute('data-step-price', total);
        tabPriceEl.textContent = formatTotal;
        tabPriceEl.setAttribute('data-step-price', total);
    }

    onFormSubmit(e) {
        e.preventDefault();
        e.target.classList.add('loading');
        const formData = new FormData();
        let inputLength = 0;
        let itemIndex = 0;
        const completeSteps = Array.from(this.steps).filter(step => !step.classList.contains('skip') && step.classList.contains('complete'));
        completeSteps.forEach((step) => {
            if (step.classList.contains('cb-step-fence')) {
                inputLength = +step.querySelector('.cb-dimension-input').value;
                const fenceLength = Math.ceil(inputLength / 5);
                const fenceVariantId = step.querySelector('.cb-variant-option.active').dataset.variantId;
                formData.set(`items[${itemIndex}][id]`, fenceVariantId);
                formData.set(`items[${itemIndex}][quantity]`, fenceLength);
                formData.set(`items[${itemIndex}][properties][_configurator]`, 'true');
                itemIndex++;
            } else if (step.classList.contains('cb-step-post')) {
                const selectedProduct = step.querySelector('.cb-product-option.active');
                const selectedCornerPost = step.querySelector('.cb-product-option-2.active');
                if (selectedProduct) {
                    const postProductId = selectedProduct.dataset.productId;
                    const relatedPost = this.activeFenceDependencies.posts.find((el) => el.productId === +postProductId);
                    const postGap = this.activeFenceDependencies.postGap;
                    const calcLength = Math.ceil(inputLength / 5) * 5;
                    const quantity = Math.ceil(calcLength / postGap);
                    const variantId = relatedPost?.variantId;
                    if (variantId && quantity) {
                        formData.set(`items[${itemIndex}][id]`, relatedPost.variantId);
                        formData.set(`items[${itemIndex}][quantity]`, quantity);
                        itemIndex++;
                    }
                }
                const cornerPostsQuantity = step.querySelector('[data-quantity-input]');
                if (+cornerPostsQuantity.value > 0 && selectedCornerPost) {
                    const relatedCornerPost = this.activeFenceDependencies.cornerPosts.find(el => el.productId === +selectedCornerPost.dataset.productId);
                    if (relatedCornerPost && relatedCornerPost.available) {
                        formData.set(`items[${itemIndex}][id]`, relatedCornerPost.variantId);
                        formData.set(`items[${itemIndex}][quantity]`, cornerPostsQuantity.value);
                        itemIndex++;
                    }
                }
            } else if (step.classList.contains('cb-step-gate')) {
                step.querySelectorAll('.cb-option-block').forEach((block) => {
                    const variantId = block.querySelector('.cb-variant-option.active').dataset.variantId;
                    const quantuty = block.querySelector('.cb-configurator-quantity-input input').value;
                    formData.set(`items[${itemIndex}][id]`, variantId);
                    formData.set(`items[${itemIndex}][quantity]`, quantuty);
                    itemIndex++;
                    
                    const selectedPostEl = block.querySelector('.cb-gate-post-option.active');
                    if (selectedPostEl) {
                        const selectedPostProductId = selectedPostEl.dataset.gatePostProductId;
                        const postVariantId = this.activeFenceDependencies.gatePosts.find(el => el.productId === +selectedPostProductId).variantId;
                        const postQuantity = quantuty * 2;
                        formData.set(`items[${itemIndex}][id]`, postVariantId);
                        formData.set(`items[${itemIndex}][quantity]`, postQuantity);
                        itemIndex++;
                    }
                });
            } else if (step.classList.contains('cb-step-extras')) {
                step.querySelectorAll('.cb-configurator-product-card:has(input[type="checkbox"]:checked)').forEach((el) => {
                    let id = el.dataset.configuratorExtraProduct;
                    const quantity = el.querySelector('.cb-configurator-quantity-input input').value;
                    if (el.dataset.hasVariants === 'true') {
                        const variantDropdown = el.querySelector('select');
                        const selectVariant = variantDropdown.options[variantDropdown.selectedIndex];
                        id = selectVariant.dataset.variantId;
                    }
                    if (+quantity > 0) {
                        formData.set(`items[${itemIndex}][id]`, id);
                        formData.set(`items[${itemIndex}][quantity]`, quantity);
                        itemIndex++;
                    }
                });
            }
        });

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => {
            return response.json().then(data => {
                if (!response.ok) {
                    throw data;
                }
                return data;
            });
        })
        .then(data => {
            e.target.classList.remove('loading');
            window.location.href = '/cart';
        })
        .catch(error => {
            e.target.classList.remove('loading');
            alert(error.description || error.message || 'Something went wrong.');
        });
    }
}
customElements.define("cb-configurator", Configurator);